module.exports = __webpack_public_path__ + "static/media/chile_icon.7968a962.png";